import { BsDownload } from "react-icons/bs";
import { useSelector } from "react-redux";
import css from "./DownloadPdfButtonArchive.module.css";
import { selectSelectedServiceId } from "../../../../redux/auth/selectors.js";
import "../../../../assets/fonts/Roboto-Regular-normal.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { selectVisibilityArchive } from "../../../../redux/visibility/selectors.js";
import { format } from "date-fns";
import { selectUserCompaniesData } from "../../../../redux/documents/selectors.js";
import { useEffect, useState } from "react";

export default function DownloadPdfButtonArchive({ carsData = [] }) {
  const userCompaniesData = useSelector(selectUserCompaniesData);
  const selectedServiceId = useSelector(selectSelectedServiceId);
  const currentCompany = userCompaniesData?.find(
    company => company.workshop_id === Number(selectedServiceId)
  );

  const visibility = useSelector(selectVisibilityArchive);

  const formatDate = dateString => {
    if (!dateString) return "Немає дати";
    return format(new Date(dateString), "dd.MM.yy | HH:mm");
  };

  // ! Форматування логотипу для швидшого завантаження
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    if (!currentCompany?.logo_url) return;

    const loadLogo = async () => {
      try {
        const response = await fetch(currentCompany.logo_url);
        const blob = await response.blob();

        const reader = new FileReader();

        reader.onloadend = () => {
          const img = new Image();

          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxWidth = 400;

            const scale = maxWidth / img.width;

            canvas.width = maxWidth;
            canvas.height = img.height * scale;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const compressedBase64 = canvas.toDataURL("image/png");

            setLogoBase64(compressedBase64);
          };

          img.src = reader.result;
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Logo load error:", error);
      }
    };

    loadLogo();
  }, [currentCompany]);

  // ! Кінець форматування

  const handleDownload = () => {
    const generatePdf = () => {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
      doc.setFont("Roboto-Regular", "normal");

      const pageWidth = doc.internal.pageSize.getWidth();

      const styles = {
        logo: { x: 14, y: 10, width: 40, height: 9 },
        dateInfo: { fontSize: 10, x: 282, y: 10 + 8, alignment: "right" },
        companyInfo: {
          fontSize: 12,
          x: 282,
          y: 10 + 8 + 5,
          alignment: "right",
        },
        statusInfo: {
          fontSize: 10,
          x: 282,
          y: 10 + 8 + 10,
          alignment: "right",
        },
        title: { fontSize: 13, x: pageWidth / 2, y: 60, alignment: "center" },
      };

      // !Назва компанії
      const currentCompany = userCompaniesData?.find(
        company => company.workshop_id === Number(selectedServiceId)
      );

      const displayServiceName = currentCompany?.workshop_name;
      const displayServiceLegalName = currentCompany?.full_name;
      const displayServiceAddress = currentCompany?.actual_address;
      const displayServicePhone = currentCompany?.phone;
      const displayServiceEmail = currentCompany?.email;
      const displayServiceTaxNumber = currentCompany?.tax_id;
      const displayServiceIban = currentCompany?.iban;

      let currentY = 20;

      const addHeaderLine = (text, size = 10, gap = 5) => {
        if (!text) return;

        doc.setFontSize(size);
        doc.text(text, 14, currentY);

        currentY += gap;
      };

      // Лого
      const logoUrl = currentCompany?.logo_url;

      if (logoUrl) {
        const imgProps = doc.getImageProperties(logoUrl);

        const maxWidth = 40;
        const maxHeight = 9;

        let width = maxWidth;
        let height = width / (imgProps.width / imgProps.height);

        if (height > maxHeight) {
          height = maxHeight;
          width = height * (imgProps.width / imgProps.height);
        }

        doc.addImage(logoUrl, "PNG", 14, 5, width, height);
      }

      addHeaderLine(displayServiceName, 12);
      addHeaderLine(displayServiceLegalName);
      addHeaderLine(displayServiceAddress);
      addHeaderLine(displayServicePhone);
      addHeaderLine(displayServiceEmail);
       {
         displayServiceTaxNumber &&
           addHeaderLine(`ІПН: ${displayServiceTaxNumber}`);
       }
       {
         displayServiceIban && addHeaderLine(`IBAN: ${displayServiceIban}`);
       }
      // !

      doc.setFontSize(styles.dateInfo.fontSize);
      const currentDate = new Date().toISOString().split("T")[0];
      doc.text(`Дата: ${currentDate}`, styles.dateInfo.x, styles.dateInfo.y, {
        align: styles.dateInfo.alignment,
      });

      doc.setFontSize(styles.title.fontSize);
      doc.text(
        "Звіт про машини додані до архіву",
        styles.title.x,
        styles.title.y
      );

      const tableData = carsData.map(car => {
        const customerName =
          `${car.customer?.first_name || ""} ${car.customer?.last_name || ""}`.trim() ||
          "Гість";

        const row = [
          visibility?.carNum ? car.vehicle?.plate || "-" : "-",
          visibility?.time ? formatDate(car.archived_at) : "—",
          visibility?.name ? customerName : "Гість",
          visibility?.status ? car.reason_add_name?.toUpperCase() || "—" : "—",
          visibility?.reasonRegistration ? car.note || "—" : "—",
          visibility?.reasonArchived ? car.comment || "—" : "—",
        ];

        return row;
      });

      autoTable(doc, {
        startY: styles.title.y + 10,
        head: [
          [
            "Номер авто",
            "Дата звернення",
            "Ім'я гостя",
            "Статус",
            "Причина запису на СТО",
            "Причина додавання в архів",
          ],
        ],
        body: tableData,
        styles: {
          fontSize: 9,
          font: "Roboto-Regular",
          fontStyle: "normal",
          halign: "center",
        },
        headStyles: {
          font: "Roboto-Regular",
          fontStyle: "normal",
          fillColor: [100, 149, 237],
          halign: "center",
        },
      });

      const now = new Date();

      const day = now.getDate().toString().padStart(2, "0");
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const year = now.getFullYear();
      const time = now.toTimeString().split(" ")[0];

      doc.save(`archive_report_${day}-${month}-${year}_${time}.pdf`);
    };

    generatePdf();
  };

  return (
    <button className={css.btnPdf} onClick={handleDownload}>
      <BsDownload className={css.btnIcon} color="var(--icon-gray)" />
      <span className={css.btnPdfText}>.pdf</span>
    </button>
  );
}
